var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPortfolioCompositionMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_221_14001)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 2,
    width: 45.1596,
    height: 45,
    rx: 12,
    fill: "#20E290",
    fillOpacity: 0.15
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_14001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0019 34.7422H17.0391V36.5H22.0019V34.7422Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0019 31.5781H17.0391V33.3359H22.0019V31.5781Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.124 31.5781H36.1611V33.3359H41.124V31.5781Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.124 34.7422H36.1611V36.5H41.124V34.7422Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.75 28.4141H29.7871V30.1719H34.75V28.4141Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7264 25.25H29.7871V27.0078H34.75L34.7264 25.25Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3759 25.25H23.4131V27.0078H28.3759V25.25Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3759 28.4141H23.4131V30.1719H28.3759V28.4141Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3759 34.7422H23.4131V36.5H28.3759V34.7422Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.75 34.7422H29.7871V36.5H34.75V34.7422Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3759 31.5781H23.4131V33.3359H28.3759V31.5781Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.75 31.5781H29.7871V33.3359H34.75V31.5781Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2964 12.5H20.5908V13.2031C20.5908 17.1406 23.3038 20.4582 26.9649 21.3978V20.9609C26.9649 19.198 27.4318 17.5418 28.2481 16.1079C26.7106 13.9277 24.1677 12.5 21.2964 12.5Z",
    fill: "#20E290"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.8669 12.5C32.185 12.5 28.376 16.2956 28.376 20.9609V23.8438H29.7872V21.6346C34.1402 21.276 37.5725 17.6317 37.5725 13.2031V12.5H36.8669Z",
    fill: "#20E290"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_221_14001",
    x: 0.5,
    y: -2.38419e-7,
    width: 56.1592,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_221_14001"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_221_14001",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_14001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0851,
    height: 24,
    fill: "white",
    transform: "translate(17.0391 12.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioCompositionMoneyIcon);
export default __webpack_public_path__ + "static/media/portfolio_composition_money_icon.36b271f2459711cc8bee3ca4d4c77b03.svg";
export { ForwardRef as ReactComponent };